import React, { Component } from "react";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { APPOINTMENT_NOTE_TYPES } from "../../modules/Appointments/util";

class AppointmentNotesConfiguration extends Component {
  handleCheckboxChange = (_e, { value, checked }) => {
    const { location, onLocationChange } = this.props;

    const enabled_appointment_note_type_ids = checked
      ? [...location.enabled_appointment_note_type_ids, value]
      : location.enabled_appointment_note_type_ids.filter(id => id !== value);

    onLocationChange({
      ...location,
      enabled_appointment_note_type_ids,
    });
  };

  handleNoteEnabledChange = (_e, { name, checked }) => {
    const { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  render() {
    const { location, t } = this.props;

    const noteTypeOptions = Object.keys(APPOINTMENT_NOTE_TYPES)
      .filter(
        key =>
          APPOINTMENT_NOTE_TYPES[key] > APPOINTMENT_NOTE_TYPES.CALL_CUSTOMER &&
          ![APPOINTMENT_NOTE_TYPES.DMS, APPOINTMENT_NOTE_TYPES.TIRESCANNER, APPOINTMENT_NOTE_TYPES.REPLACEMENT_CAR, APPOINTMENT_NOTE_TYPES.HIGH_VOLTAGE_WARNING].includes(
            APPOINTMENT_NOTE_TYPES[key]
          )
      )
      .map(key => {
        const value = APPOINTMENT_NOTE_TYPES[key];
        const text = key.toString().toLowerCase();

        return { text: t(text).message || text.replaceAll("_", " "), value, key: value };
      });

    return (
      <>
        <Segment>
          <Header as="h5">
            <Icon name="sticky note" />
            <Header.Content>{t("notes").message || "Notes"}</Header.Content>
          </Header>
          <Segment>
            <Form>
              <Form.Field className="full-width-input">
                <Checkbox
                  name="is_car_note_enabled"
                  checked={location.is_car_note_enabled}
                  onChange={this.handleNoteEnabledChange}
                  label={t("car_note").message || "Car note"}
                />
              </Form.Field>
              <Form.Field className="full-width-input">
                <Checkbox
                  name="is_customer_note_enabled"
                  checked={location.is_customer_note_enabled}
                  onChange={this.handleNoteEnabledChange}
                  label={t("customer_note").message || "Customer note"}
                />
              </Form.Field>
            </Form>
          </Segment>
        </Segment>
        <Segment>
          <Header as="h5">
            <Icon name="note sticky" />
            <Header.Content>{t("additional_appointment_note_types").message || "Additional Appointment Note Types"}</Header.Content>
          </Header>
          <Segment>
            <Form>
              {noteTypeOptions.map(option => (
                <Form.Field key={option.key} className="full-width-input">
                  <Checkbox
                    value={option.key}
                    checked={location.enabled_appointment_note_type_ids?.includes(option.value)}
                    onChange={this.handleCheckboxChange}
                    label={option.text}
                  />
                </Form.Field>
              ))}
            </Form>
          </Segment>
        </Segment>
      </>
    );
  }
}

export default withTranslation()(AppointmentNotesConfiguration);
